import TodoList from './components/TodoList';

const App = () => {
  return (
    <div className="container py-5">
      <h1 className='fw-bold mb-3'>App ToDos</h1>
      <TodoList />
    </div>
  );
};

export default App;
